const mediaId = page => page.data.previewImage || page.data.thumbnail || null;

// used in home component
export const toEvent = event => ({
  ...event,
  startDate: event.data.startDate || null,
  endDate: event.data.endDate || null,
  place: event.data.place || null,
  mediaId: mediaId(event),
});

// used in home component
export const toNews = (news, i, all) => ({
  ...news,
  abstract: news.data.abstract,
  startDate: news.data.startDate || null,
  endDate: news.data.endDate || null,
  subtitle: news.data.subtitle,
  mediaId: mediaId(news),
  lastRow: all.length >= 2,
});

export const toSearchResults = result => ({
  score: result.score,
  ...result.result,
  mediaId:
    result.result.data.previewImage || result.result.data.thumbnail || null,
  date: result.result.data.date,
  startDate: result.result.data.startDate || null,
  endDate: result.result.data.endDate || null,
});

export const toMarketNews = page => ({
  uuid: page.uuid,
  title: page.title,
  type: page.type,
  abstract: page.data.abstract,
  startDate: page.data.startDate || null,
  endDate: page.data.endDate || null,
  createdAt: page.createdAt,
  subtitle: page.data.subtitle,
  tags: page.tags,
  mediaId: mediaId(page),
  data: page.data,
});
